<template>
  <div>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-money-check-alt"></i> Rachunki</h3>
        <div>
          <b-button variant="outline-primary" v-b-modal.category-modal>
            <i class="fas fa-tools"></i> Zarządzaj kategoriami
          </b-button>
          <button class="btn btn-outline-primary" @click="exportXls()" :disabled="exporting">
            <b-spinner small v-show="exporting"></b-spinner>
            <i class="fas fa-file-export" v-show="!exporting"></i> Exportuj raport
          </button>
          <button class="btn btn-outline-primary" @click="showModal(false, 'bill-modal')">
            <i class="fas fa-plus"></i> Dodaj rachunek
          </button>
        </div>
      </div>
      <div class="portlet-body">
        <BillsSearchPanel
          @filtersChanged="getBills"
          @subcontractorsChanged="filterBySubcontractors"
        />
        <BillsCategoryModalForm />
        <b-table
          class="table table-list table-mobilepro bills-table"
          ref="bills_table"
          :fields="fields"
          :busy.sync="isBusy"
          :items="items"
          stacked="lg"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          sort-icon-left
        >
          <template v-slot:table-busy>
            <TableSpiner />
          </template>

          <template v-slot:head(vat_amount)="data">
            Mswt
          </template>
          <template v-slot:head(discount_value)="data">
            Nachlass
          </template>
          <template v-slot:head(skonto_value)="data">
            skonto
          </template>
          <template v-slot:head(final_amount)="data">
            Suma<br/>brutto
          </template>

          <template v-slot:cell(issue_date)="data">{{ data.item.issue_date }}</template>
          <template v-slot:cell(number)="data">{{ data.item.number }}</template>
          <template v-slot:cell(construction)="data">
            <div v-for="(item, index) in data.item.construction" :key="index">
              <router-link
                :to="'/construction/'+item.value"
                class="badge badge-light"
                tag="a"
              >{{item.text}}</router-link>
            </div>
          </template>
          <template v-slot:cell(bills_category_name)="data">
            <div
              class="badge badge-info"
              v-if="data.item.bills_category_id !== 2"
            >{{ data.item.bills_category_name }}</div>
            <div class="badge badge-secondary" v-else>{{ data.item.subcontractor.text || "Brak"}}</div>
          </template>
          <template v-slot:cell(amount)="data">
            <div v-if="data.item.currency !== getMainBaseCurrency">
              {{ parseFloat(data.item.netto_amount/data.item.exchange_rate).toFixed(2) }}
              <br/><small class="exhange-info">{{ parseFloat(data.item.netto_amount).toFixed(2) }}</small>
            </div>
            <div v-else>
              {{ parseFloat(data.item.netto_amount).toFixed(2) }}
            </div>
          </template>
          <template v-slot:cell(vat_amount)="data">
            <div v-if="data.item.currency !== getMainBaseCurrency">
              {{ parseFloat(data.item.vat_amount/data.item.exchange_rate).toFixed(2) }}
            <br/><small class="exhange-info">{{ data.item.vat_amount }}</small>
            </div>
            <div v-else>
              {{ parseFloat(data.item.vat_amount).toFixed(2) }}
            </div>
          </template>
          <template v-slot:cell(discount_value)="data">{{ data.item.discount_value }}</template>
          <template v-slot:cell(skonto_value)="data">
            <div v-if="data.item.currency !== getMainBaseCurrency">
              {{ parseFloat(data.item.skonto_value/data.item.exchange_rate).toFixed(2) }}
              <br/><small class="exhange-info">{{ data.item.skonto_value }}</small>
            </div>
            <div v-else>
              {{ parseFloat(data.item.skonto_value).toFixed(2) }}
            </div>
          </template>
          <template v-slot:cell(final_amount)="data">
            <div v-if="data.item.currency !== getMainBaseCurrency">
              {{ parseFloat(data.item.final_amount/data.item.exchange_rate).toFixed(2) }}
              <br/><small class="exhange-info">{{ data.item.final_amount }}</small>
            </div>
            <div v-else>
              {{ parseFloat(data.item.final_amount).toFixed(2) }}
            </div>
          </template>
          <template v-slot:cell(currency)="data">
            <div v-if="data.item.currency !== getMainBaseCurrency">
              {{getMainBaseCurrency}}
              <br/><small class="exhange-info">{{ data.item.currency }}</small>
            </div>
            <div v-else>
              {{ data.item.currency }}
            </div>
          </template>
          <template v-slot:cell(options)="data">
            <div class="text-right text-lg-center">
              <b-dropdown no-caret right variant="light" class="btn-rounded">
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button @click="showModal(data.item.id,'bill-modal')">Edytuj</b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button class="danger" @click="confirmRemove(data.item)">
                  <i class="fas fa-trash-alt"></i> Usuń
                </b-dropdown-item-button>
              </b-dropdown>
            </div>
          </template>
        </b-table>
      </div>
    </div>
    <BillsModalForm :bill="this.selected" @onClose="onClose" @onSubmit="onSubmit" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BillsService from "@/services/bills.service";

// Komponenty
import TableSpiner from "../components/TableSpiner";
import BillsModalForm from "@/components/bills/BillsModalForm";
import BillsSearchPanel from "@/components/bills/BillsSearchPanel";
import BillsCategoryModalForm from "@/components/bills/BillsCategoryModalForm";

export default {
  name: "TheBillsList",
  components: {
    TableSpiner,
    BillsModalForm,
    BillsSearchPanel,
    BillsCategoryModalForm,
  },
  data() {
    return {
      exporting: false,
      filter: null,
      sortBy: "issue_date",
      sortDesc: false,
      selected: {},
      isBusy: false,
      items: null,
      fields: [
        { key: "issue_date", label: "Data", sortable: true },
        { key: "bills_category_name", label: "Kategoria", sortable: true },
        { key: "construction", label: "Budowa" },
        { key: "number", label: "RE Nr" },
        { key: "amount", label: "Netto", class: "text-right" },
        { key: "vat_amount", class: "text-right" },
        { key: "discount_value", class: "text-right" },
        { key: "skonto_value", class: "text-right" },
        { key: "final_amount", class: "text-right" },
        { key: "currency", label: "Waluta", class: "text-right" },
        { key: "options", label: "Opcje", class: "text-center" },
      ],
    };
  },
  computed: {
    ...mapGetters("bills", ["bills", "search"]),
    ...mapGetters("company", ["getMainBaseCurrency"]),
  },
  created() {
    this.getBills();
  },
  methods: {
    ...mapActions("bills", ["doSearch", "remove"]),
    getBills() {
      this.isBusy = true;
      return this.doSearch(this.search)
        .then(() => {
          this.isBusy = false;
          this.filterBySubcontractors();
        })
        .catch(() => {
          this.isBusy = false;
          this.items = [];
        });
    },
    filterBySubcontractors() {
      let searchSubcontractors = [];
      this.$_.each(this.search.filter, (o) => {
        if (o.flag) {
          searchSubcontractors.push(o.id);
        }
      });
      if (searchSubcontractors.length === 0) {
        this.items = this.bills;
      } else {
        this.items = [];
        this.$_.each(this.bills, (item) => {
          if (item.bills_category_id !== 2) {
            this.items.push(item);
          } else if (
            searchSubcontractors.indexOf(item.subcontractor.value) > -1
          ) {
            this.items.push(item);
          }
        });
      }
    },
    showModal(bill_id) {
      if (bill_id) {
        this.selected = this.$_.find(this.items, { id: bill_id });
      }
      this.$nextTick(() => {
        this.$bvModal.show("bill-modal");
      });
    },
    onClose() {
      this.selected = {};
    },
    onSubmit() {
      this.$refs.bills_table.refresh();
      this.$nextTick(() => {
        this.$bvModal.hide("bill-modal");
      });
    },
    confirmRemove(bill) {
      let h = this.$createElement;
      this.$bvModal
        .msgBoxConfirm(
          [
            h("p", [
              "Czy napewno chcesz usunąć rachunek o numerze ",
              h("br"),
              h("br"),
              h("strong", bill.number),
              " ?",
            ]),
          ],
          {
            title: "Potwierdź usunięcie rachunku",
            okVariant: "danger",
            okTitle: "TAK",
            cancelTitle: "NIE",
          }
        )
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          this.remove(bill.id).then(() => {
            this.$refs.bills_table.refresh();
          });
        });
    },
    exportXls() {
      this.exporting = true;
      BillsService.doExportXls(this.search)
        .then((filename) => {
          window.location =
            process.env.VUE_APP_ROOT_API + "bills/download/" + filename;
        })
        .finally(() => {
          this.exporting = false;
        });
    },
  },
};
</script>
